import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '@shared-angular/services/language.service';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { ButtonModule } from "primeng/button";
import { SelectModule } from 'primeng/select';
import { SafePipe } from 'src/app/shared/pipes/safe.pipe';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { BlocklyTabComponent } from "../blockly-tab/blockly-tab.component";
import { FullscreenLayoutingService } from './fullscreen-layouting.service';

@Component({
  imports: [BlocklyTabComponent, SafePipe, FormsModule, ButtonModule, SelectModule],
  templateUrl: './blockly-tab-fullscreen.component.html',
  styleUrl: './blockly-tab-fullscreen.component.scss',
  host: { class: 'split-container' }
})

export class BlocklyTabFullscreenComponent implements OnInit, OnDestroy {



  @ViewChild('left', { static: false }) public left!: ElementRef<HTMLDivElement>;
  @ViewChild('right', { static: false }) public right!: ElementRef<HTMLDivElement>;
  @ViewChild('resizer', { static: false }) public resizer!: ElementRef<HTMLDivElement>;

  public readonly botTypes = ["", "/audio", "/avatar"] as const;
  public botTypeToLabel = new Map<typeof this.botTypes[number], string>([
    ["", $localize`:@@chat-bot:Chat-Bot`],
    ["/audio", $localize`:@@audio-bot:Audiobot`],
    ["/avatar", $localize`:@@avatar-bot:Avatar-Bot`]
  ]);
  public selectedBotType: typeof this.botTypes[number] = "";

  constructor(public langService: LanguageService, public rss: RouteShareService, private host: ElementRef<HTMLElement>, public fullscreenLayout: FullscreenLayoutingService, public toastr: ToastrService) {

  }

  private isResizing = false;

  /* ---------- Lebenszyklus ---------- */
  /* ngAfterViewInit(): void {
    /*  optional: Startbreite definieren
        this.left.nativeElement.style.width = '50%';
} */

  /* ---------- Events ---------- */
  public startResize(_: MouseEvent): void {
    this.isResizing = true;
    document.body.style.cursor = 'col-resize';
  }

  @HostListener('document:mousemove', ['$event'])
  public onMouseMove(e: MouseEvent): void {
    if (this.isResizing) {
      this.host.nativeElement.classList.add('is-resizing');
    } else {
      this.host.nativeElement.classList.remove('is-resizing');
    }
    if (!this.isResizing) return;


    const containerRect = this.host.nativeElement.getBoundingClientRect();
    const pointerX = e.clientX - containerRect.left;            // Cursor relativ zum Container
    const leftWidth = Math.max(100, pointerX);
    this.left.nativeElement.style.width = `${leftWidth.toString()}px`;
    //this.right.nativeElement.style.width = `${rightWidth}px`;
  }

  @HostListener('document:mouseup')
  public stopResize(): void {
    if (this.isResizing) {
      this.isResizing = false;
      document.body.style.cursor = 'default';
    }
  }





  public ngOnInit() {
    document.body.classList.add('layout-full');
  }

  public ngOnDestroy() {
    document.body.classList.remove('layout-full');
  }


  protected async resetBot() {
    const frame = document.getElementById("botframe") as HTMLIFrameElement;
    try {
      if (frame.contentWindow) {
        await frame.contentWindow.RAGAI.resetBot();
        frame.contentWindow.location.reload();
      } else {
        this.toastr.error("GENERAL", $localize`:@@error-resetbot:Fehler beim Zurücksetzen. Versuche es erneut.`);
      }
    } catch (_e) {
      this.toastr.error("GENERAL", $localize`:@@error-resetbot:Fehler beim Zurücksetzen. Versuche es erneut.`);
    }
  }


}

